<template>
    <gj-modal
        v-bind="$attrs"
        v-on="$listeners"
        :visible.sync="modalVisible"
        size="normal"
        :confirmLoading="confirmLoading"
        :confirmDisabled="isMeaningless(orderIds)"
        notFooterPadding
        @cancel="cancel"
        @confirm="confirm">
        <template #header>
            <span>添加匹配订单</span>
        </template>
        <template #content>
            <el-row type="flex">
                <span :span="6" class="label-pd"><label class="required-color">*</label>匹配订单编号: </span>
                <span :span="18" style="width: 100%">
                    <gj-textarea
                        v-model="orderIds"
                        placeholder="回车添加多个匹配订单编号"
                        style="width: 100%"
                        :styles="{width: '100%', height: '120px'}"
                    >
                    </gj-textarea>
                </span>
            </el-row>
        </template>
    </gj-modal>
</template>

<script>
    import {isMeaninglessMixin, modalMixIn} from "../../../../../minxins";
    import GjTextarea from "../../../../../components/input/gj-textarea";
    import {reviewAddMatchOrder} from "../../../../../api/sale";

    export default {
        name: "app-review-batch-match-order",
        components: {GjTextarea},
        mixins:[modalMixIn, isMeaninglessMixin],
        props: {
            id: {
                type: Number,
                require: true,
            },
            marketId: {
                require: true,
            }
        },
        data() {
            return {
                confirmLoading: false,
                orderIds: ''
            }
        },
        methods: {
            confirm() {
                this.confirmLoading = true;
                const orderList = this.orderIds.split("\n");
                reviewAddMatchOrder({id: this.id, marketId: this.marketId, orderIds: orderList})
                    .then(data => {
                        this.$emit('created');
                        this.$gjDestroy();
                    })
                    .complete(() => this.confirmLoading = false);
            }
        }
    }
</script>

<style scoped>
    .required-color {
        color: red;
    }
    .label-pd {
        min-width: 100px;
    }
    .pd20 {
        padding-top: 20px;
        padding-bottom: 20px;
    }
</style>
